// @flow
import React from 'react'
import I18n from 'i18n-react'

// components
import FieldForm from './FieldForm.jsx'
import type { ProductContent } from '../Types/ProductContent'
import type { ResourcesType } from '../Types/Resources'
import type { ExpandedSpecificationDTO } from '../Types/Field'
import type { FormValueType } from '../Types/Values'
import type { InputHelpsType } from '../Types/InputHelpType'
//types
type DiscountsProps = {
  activeTabKey: string,
  className: string,
  content: ProductContent,
  cicEnabled: boolean,
  data: { [key: string]: any },
  debug: boolean,
  onChange: (key: string, value: FormValueType, pathArray: Array<string>) => void,
  onRecount: () => void,
  onReset: () => void,
  pushIsPristine: boolean,
  resources: ResourcesType,
  inputHelps: InputHelpsType,
  specification: ExpandedSpecificationDTO,
  validationErrors: { [key: string]: { [key: string]: string } },
}

type DiscountsState = {
  prevSpecificationString: string,
  prevContentString: string,
  specification: ExpandedSpecificationDTO,
  content: ProductContent,
  prevActiveTabKey: string,
}

const labelClasses = {
  radioRefSelect: 'col-12',
  string: 'col-12',
}

const fieldsClasses = {
  radioRefSelect: 'col-12',
  bool: 'col-12',
  string: 'col-12',
}

export default class Discounts extends React.Component<DiscountsProps, DiscountsState> {
  state = {
    prevSpecificationString: '',
    prevContentString: '',
    specification: {},
    content: {},
    prevActiveTabKey: '',
  }

  static getDerivedStateFromProps = (nextProps: DiscountsProps, prevState: DiscountsState) => {
    if (
      (JSON.stringify(nextProps.specification) !== prevState.prevSpecificationString ||
        JSON.stringify(nextProps.content) !== prevState.prevContentString ||
        nextProps.activeTabKey !== prevState.prevActiveTabKey) &&
      nextProps.content.types
    ) {
      let activeContent = {
        ...nextProps.content,
        types: Object.keys(nextProps.content.types).reduce((typesAcc, typeKey) => {
          typesAcc[typeKey] = {
            ...nextProps.content.types[typeKey],
            components:
              Object.keys(nextProps.content.types[typeKey].fieldNames).filter((fieldName) =>
                fieldName.includes('commercial'),
              ).length > 1 &&
              nextProps.activeTabKey !== 'tplCic' &&
              nextProps.content.types[typeKey].components
                ? Object.keys(nextProps.content.types[typeKey].components).reduce((typeComponentAcc, componentKey) => {
                    const show =
                      (nextProps.activeTabKey === 'tpl' && componentKey === 'commercialTpl') ||
                      (nextProps.activeTabKey === 'cic' && componentKey === 'commercialCic')
                    typeComponentAcc[componentKey] = {
                      ...nextProps.content.types[typeKey].components[componentKey],
                      showLabel: !show,
                      hidden: !show,
                    }
                    return typeComponentAcc
                  }, {})
                : nextProps.content.types[typeKey].components,
          }
          return typesAcc
        }, {}),
      }
      return {
        prevSpecificationString: JSON.stringify(nextProps.specification),
        prevContentString: JSON.stringify(nextProps.content),
        specification: nextProps.specification,
        content: activeContent,
      }
    }
    return null
  }

  handleOnChange = (key: string, value: FormValueType, pathArray: Array<string>) => {
    this.props.onChange(key, value, pathArray)
  }

  handleOnReset = () => {
    this.props.onReset()
  }

  handleOnRecount = () => {
    this.props.onRecount()
  }

  render() {
    const {
      cicEnabled,
      activeTabKey,
      data,
      debug,
      inputHelps,
      onChangeFormData,
      pushIsPristine,
      resources,
      validationErrors,
    } = this.props
    const { content, specification } = this.state

    return (
      <div className="card flex-row flex-wrap px-4 py-3 px-md-3 py-md-0 h-sm-auto">
        <div className="d-lg-flex d-xl-block align-items-center py-2 w-100">
          <div className="d-block align-items-center mb-5 mb-lg-3">
            <strong className="d-block mt-2 mb-1 mt-md-0 mb-md-0 mr-4">
              {I18n.translate('components.discounts.title')}
            </strong>
            <FieldForm
              blockClassName="col-12 p-0"
              blockContentClassName=""
              content={content}
              data={data}
              debug={debug}
              fieldsClasses={fieldsClasses}
              formData={data}
              miniApps={{
                'CarAllianz-commercial': ['allianzDiscountApp'],
              }}
              miniAppData={{
                cicEnabled,
                activeTabKey,
              }}
              inputHelps={inputHelps}
              formGroupClassName="form-group d-flex flex-row flex-wrap flex-sm-row align-items-top mb-2"
              labelClasses={labelClasses}
              onChangeValue={this.handleOnChange}
              onChangeFormData={onChangeFormData}
              pushIsPristine={pushIsPristine}
              resources={resources}
              showBlockTitle={false}
              specification={specification}
              validationErrors={validationErrors}
            />
          </div>
        </div>
        <hr className="d-none d-lg-block d-xl-none m-0 w-100" />
        <div className="text-center w-100">
          <hr className="d mt-0 w-100" />
          <div className="row flex-nowrap align-items-center mb-3">
            <div className="col">
              <button
                className="btn btn-dark px-3 w-100"
                onClick={this.handleOnRecount}
                type="button"
              >
                {I18n.translate('components.discounts.recount')}
              </button>
            </div>
            <div className="col">
              <a className="btn btn-link" onClick={this.handleOnReset}>
                <strong>{I18n.translate('components.discounts.reset')}</strong>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
